import { concat, ReplaySubject, Subject } from 'rxjs';
import { distinct, filter, first, map } from 'rxjs/operators';
import { inject, injectable } from 'inversify';
import { INotificationMutationReadService } from './notification-mutation-read.interface';
import { INotificationMutationService, NotificationMutationObservable } from '../../../interfaces';
import { IPersistenceAdapterService, PERSISTENCE_ADAPTER_SERVICE } from '../../message-adapters/persistence-adapter';
import { singlePropertyMutation } from '../../../helpers/object-utils';
import { StateObjectTransformationCollection } from '../../../helpers';

@injectable()
export class NotificationMutationReadService implements INotificationMutationService, INotificationMutationReadService {

    @inject(PERSISTENCE_ADAPTER_SERVICE) private readonly adapter: IPersistenceAdapterService;

    private readonly read$: Subject<string> = new ReplaySubject<string>();

    read = (notificationId: string): void => this.read$.next(notificationId);

    mutations = (): NotificationMutationObservable =>
        concat(
            this.adapter.settingsObs([ 'readNotifications' ]).pipe(
                first(),
                map(data => StateObjectTransformationCollection.readNotifications(data.readNotifications)),
            ),
            this.read$.pipe(distinct(), map(id => [ id ])),
        ).pipe(
            filter(items => items?.length > 0),
            map(notificationIds => notificationIds.map(
                id => ({ id, action: singlePropertyMutation('haveBeenSeen', true) }),
            )),
        );
}
